<template>
  <div>
    <div class="mx-5 py-5 d-flex justify-space-between">
      <h5>Add New Courses</h5>
      <v-icon style="color: rgba(8, 8, 22, 0.6)" class="ml-8" @click="close()"
        >mdi-close</v-icon
      >
    </div>

    <v-card color="#F6F8FC" flat class="px-5">
      <v-form v-model="valid" class="py-4">
        <v-container class="">
          <!-- <span class="text-stl">Trainee </span>
          <v-select
            class="pt-0"
            v-model="select"
            :items="items"
            item-text="state"
            item-value="abbr"
            label="Select"
            attach
            persistent-hint
            return-object
            single-line
          ></v-select> -->
          <span class="text-stl">Course of Training </span>
          <v-select
            class="pt-0"
            v-model="form.CourseId"
            :items="ActiveCourses"
            item-text="Title"
            item-value="Id"
            label="Select a Course"
            attach
            single-line
            :error-messages="
              $v.form.CourseId.$error ? 'Course is required' : null
            "
          ></v-select>
          <span class="text-stl">Trainer </span>
          <v-select
            class="pt-0"
            v-model="form.TrainerId"
            :items="GetAllInstructorsIDsAndNames"
            item-text="Name"
            item-value="Id"
            label="Select a Training Instructor"
            attach
            single-line
            :error-messages="
              $v.form.TrainerId.$error ? 'Trainer is required' : null
            "
          ></v-select>
          <div>
            <span class="text-stl">Date Started </span>
            <v-menu
              ref="menu1"
              v-model="menu1"
              :close-on-content-click="false"
              :return-value.sync="form.DateStarted"
              transition="scale-transition"
              offset-y
              min-width="auto"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  single-line
                  dense
                  v-model="form.DateStarted"
                  label=""
                  append-icon="mdi-calendar-range-outline"
                  v-bind="attrs"
                  v-on="on"
                  :error-messages="
              $v.form.DateStarted.$error ? 'Date Started is required' : null
            "
                ></v-text-field>
              </template>
              <v-date-picker v-model="form.DateStarted" no-title scrollable>
                <v-spacer></v-spacer>
                <v-btn text color="primary" @click="menu1 = false">
                  Cancel
                </v-btn>
                <v-btn
                  text
                  color="primary"
                  @click="$refs.menu1.save(form.DateStarted)"
                >
                  OK
                </v-btn>
              </v-date-picker>
            </v-menu>
          </div>
          <div class="mt-4">
            <span class="text-stl">Date Graduated </span>
            <v-menu
              ref="menu2"
              v-model="menu2"
              :close-on-content-click="false"
              :return-value.sync="form.DateGraduated"
              transition="scale-transition"
              offset-y
              min-width="auto"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  single-line
                  dense
                  v-model="form.DateGraduated"
                  label=""
                  append-icon="mdi-calendar-range-outline"
                  v-bind="attrs"
                  v-on="on"
                  ></v-text-field>
                  <!-- :error-messages="
                    $v.form.DateGraduated.$error ? 'Date Graduated is required' : null
                  " -->
              </template>
              <v-date-picker v-model="form.DateGraduated" no-title scrollable :min="form.DateStarted">
                <v-spacer></v-spacer>
                <v-btn text color="primary" @click="menu2 = false">
                  Cancel
                </v-btn>
                <v-btn
                  text
                  color="primary"
                  @click="$refs.menu2.save(form.DateGraduated)"
                >
                  OK
                </v-btn>
              </v-date-picker>
            </v-menu>
          </div>
          <div class="mt-3">
            <span class="text-stl">Credential Earned </span>
            <v-select
              class="pt-2"
              v-model="form.CredentialEarned"
              :items="credentailsitems"
              label="Select Credentials"
              single-line
              ></v-select>
              <!-- :error-messages="
                $v.form.CredentialEarned.$error ? 'Credential Earned is required' : null
              " -->
          </div>
        </v-container>
      </v-form>
      <div class="d-flex justify-end mt-3">
        <v-btn
          color="#C4C4C4"
          class="white--text py-5 px-8 mb-6"
          depressed
          @click="close()"
          ><span class="text_style">Cancel</span>
        </v-btn>
        <v-btn
          color="primary"
          class="white--text py-5 px-8 ml-4"
          depressed
          :disabled="btnloader"
          @click="save()"
          ><span v-if="btnloader != true"> Save </span>
          <v-progress-circular
            indeterminate
            size="20"
            v-else
            class="px-5"
            color="white"
            v-show="btnloader"
          ></v-progress-circular
        ></v-btn>
      </div>
    </v-card>
  </div>
</template>

<script>
import { required } from "vuelidate/lib/validators";
// import VueDropify from "vue-dropify";
// import vue2Dropzone from "vue2-dropzone";
// import "vue2-dropzone/dist/vue2Dropzone.min.css";
import { mapGetters } from "vuex";
export default {
  name: "",
  components: {
    // VueDropify,
    // vueDropzone: vue2Dropzone,
  },
  computed: {
    ...mapGetters([
      "GetAllInstructorsIDsAndNames",
      "GetCourses",
      "GetCoursesIDsAndTitle",
      "GetLoggedInUser",
      "GetPreviewUser",
    ]),
    ActiveCourses() {
      return this.$store.getters.GetActiveCoursesList;
    },
  },
  data() {
    return {
      publishdate: "",
      graduatedate: "",
      menu2: false,
      menu1: false,
      select: { state: "Gillbert Sherry", abbr: "FL" },
      items: [
        { state: "Gillbert Sherry", abbr: "FL" },
        { state: "Florida", abbr: "" },
      ],
      credentailsitems: [" BAT", "CBI", "SrCBI", "CBI-A", "BrI", "MSI", "FFI"],
      btnloader: false,
      form: {
        CourseId: null,
        TrainerId: null,
        UserId: 0,
        DateStarted: "",
        DateGraduated: "",
        CredentialEarned: "",
        CreatedBy: 0,
      },
    };
  },
  validations:{
    form:{
      CourseId:{
        required
      },
      TrainerId:{
        required
      },
      DateStarted:{
        required
      },
      DateGraduated:{
        // required
      },
      CredentialEarned:{
        // required
      }
    }
  },
  mounted() {
    const obj= {
      page: 1,
      pageSize: "all"
    }
    this.$store.dispatch("GetActiveCoursesList",obj)
    this.form.UserId = this.GetPreviewUser.Id;
    this.form.CreatedBy = this.GetLoggedInUser.Id;
    this.$store.dispatch("GetAllInstructorsIDsAndNames");
  },
  methods: {
    close() {
      this.$emit("close");
    },
    save() {
      this.$v.form.$touch()
      if(this.$v.form.$invalid){
        return
      }
      this.btnloader = true;
      this.$store.dispatch("CourseTaught", this.form).then((res) => {
        if(res.Status){
          this.close();
          this.btnloader = false;
          this.$swal.fire({
            toast: true,
            icon: "success",
            position: "top-end",
            title: "Course added successfully",
            showConfirmButton: false,
            timer: 3000,
          });
        }else {
          this.close();
          this.btnloader = false;
          this.$swal.fire({
            toast: true,
            icon: "error",
            position: "top-end",
            title: res.Message,
            showConfirmButton: false,
            timer: 3000,
          });
        }
      });
    },
  },
};
</script>

<style scoped>
.vue-dropzone {
  padding: 0;
  background: transparent;
  border-style: dashed;
}
.text-stl {
  font-family: "DM Sans";
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  color: #0d0d0d;
}
</style>
